/* @jsxImportSource @emotion/react */
/* eslint-disable formatjs/no-literal-string-in-jsx */
import React from 'react'
import { css } from '@emotion/react'
import classNames from 'classnames'
import { FormattedMessage } from 'react-intl'

import {
  Breadcrumb,
  BreadcrumbItem,
  Button,
  CustomNoteIcon,
  IconButton,
} from '@slite/components'
import { CommentsEmptyIcon, FavoriteEmptyIcon, MoreIcon } from '@slite/icons'

import { SMALL_BREAKPOINT } from '../../../../utils/breakpoints'
import type { DocNode } from './content'

// `&&` doubles the selector specificity so this rule wins over the
// `.flexbox { display: flex }` utility on the same element.
const topbarActionsCss = css`
  @media (max-width: ${SMALL_BREAKPOINT}px) {
    && {
      display: none;
    }
  }
`

export const Topbar = ({ breadcrumb }: { breadcrumb: DocNode[] }) => (
  <div
    className="flexbox flexbox-align-center flexbox-gap-12 background-shade-100 padding-right-12 flexbox-no-shrink"
    style={{ height: 52, paddingLeft: 16, minWidth: 0 }}
  >
    <div
      className="flexbox flexbox-align-center flexbox-grow flexbox-shrink overflow-hidden"
      style={{
        minWidth: 0,
      }}
    >
      <Breadcrumb
        className="font-weight-regular overflow-hidden"
        disablePopover
        maxItemsWithoutPopover={4}
      >
        {breadcrumb.map((node, idx) => (
          <BreadcrumbItem
            key={node.id}
            icon={CustomNoteIcon}
            iconProps={{
              iconShape: node.icon?.shape ?? null,
              iconColor: node.icon?.color ?? null,
              size: 14,
            }}
            renderLabel={({ className, style }) => (
              <span
                className={classNames(className, {
                  'font-weight-semibold shade-05':
                    idx === breadcrumb.length - 1,
                })}
                style={style}
              >
                {node.title}
              </span>
            )}
          />
        ))}
      </Breadcrumb>
    </div>
    <div
      className="flexbox flexbox-align-center flexbox-no-shrink"
      css={topbarActionsCss}
      style={{ gap: 2 }}
    >
      <Button variant="tertiary" size="normal">
        <FormattedMessage
          id="new.hero.demo.topbar.share"
          defaultMessage="Share"
        />
      </Button>
      <IconButton variant="tertiary" size="normal" icon={FavoriteEmptyIcon} />
      <IconButton variant="tertiary" size="normal" icon={CommentsEmptyIcon} />
      <IconButton variant="tertiary" size="normal" icon={MoreIcon} />
    </div>
  </div>
)
